import React, { useEffect, useState } from "react";
import { errorMsg, successMsg } from "../../Toastify";
import { useSelector } from "react-redux";
import {
  GetAllLeaveList,
  GetLeaveTransfer,
  UpdateLeaveMaster,
} from "../../../Repository/Api";
import CustomModal from "../../CustomModal";
import { Link } from "react-router-dom";
const itemsPerPage = 10;

const Leavemaster = () => {
          const { first_name, desingation, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token
  const [currentPage, setCurrentPage] = useState(1);
  const [dummyleaveList, setdummyLeaveList] = useState([]);

  const [searchText, setSearchText] = useState('')
  

  const SearchfilteredData = dummyleaveList?.filter(item =>
    Object.values(item).some(value =>
      value?.toString().toLowerCase().includes(searchText.toLowerCase())
    )
  );
  useEffect(() => {
    if (searchText) {
      setLeave(SearchfilteredData)
      setCurrentPage(1)
    } else {
      setLeave(dummyleaveList)
    }
  }, [searchText, dummyleaveList])
  const [leave, setLeave] = useState([]);
  const [masterModel, setMasterModel] = useState(false);
  const [createLeave, setCreateLeave] = useState({});
  const [validation, setValidation] = useState({});


  useEffect(() => {
    getLeaveList();
  },[]);

  const getLeaveList = async () => {
    const response = await GetAllLeaveList(token);
    if (response && response.statusCode === 200) {
      // setLeave(response?.data?.leave_types);
      setdummyLeaveList(response?.data?.leave_types)
    } else {
      errorMsg(response?.message);
    }
  };

  const getNextLeaveList = async () => {
    const response = await GetLeaveTransfer(token);
    if (response && response.statusCode === 200) {
      successMsg(response.message);
    } else {
      errorMsg(response.message);
    }
  };
  const setData = (e, key) => {
    let TempData = createLeave;
    TempData[key] = e;
    setCreateLeave(TempData);
    if (validation[key]) setValidation({ ...validation, [key]: false });
  };
  const handleUpdate = async (e) => {
    e.preventDefault();
    const Payload = {
      id: createLeave.id,
      name: createLeave.name,
      status: createLeave.status,
    };
    const response = await UpdateLeaveMaster(Payload, token);
    if (response && response.statusCode === 200) {
      successMsg(response.message);
      setCreateLeave({});
      setMasterModel(false);
      e.target.reset();
      getLeaveList();
    } else {
      errorMsg(response.message);
    }
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = leave.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <>
      <div>
        <div className="row justify-content-center mt-3">
          <div className="col-lg-6">
            <div class="input-group flex-nowrap">
              <span class="input-group-text" id="addon-wrapping"><span class="material-symbols-outlined search-input-icon">search</span></span>
              <input type="text" class="form-control search-table-data"
                placeholder="Search"
                aria-describedby="addon-wrapping"
                name="search"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>
          </div>
          <button
            type="button"
            className="btn  add-btn  col-lg-4"
            onClick={getNextLeaveList}
          >
            <span className="align-middle"> Transfer To Next year</span>
          </button>

        </div>

        <div className="graphbox">
          <table className="table table-hover">
            <thead>
              <tr>
                <th scope="col">S.No</th>
                <th scope="col">Leave Name</th>
                <th scope="col">Status</th>
                <th scope="col">Restriction</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.length > 0 ? (
                currentItems &&
                currentItems.map((holi, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td
                      className="namelink"
                      onClick={() => {
                        setMasterModel(true);
                        setCreateLeave(holi);
                      }}
                    >
                      {holi?.name}
                    </td>
                    <td className="textformat">{holi.status}</td>
                    <td className="viewoption">
                      <Link
                        to={`/app/Systemadmin/SystemadminLeaveRestriction/${holi?.id}`}
                      >
                        View
                      </Link>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td></td>
                  <td></td>
                  <td>
                    <div> No Data Found </div>
                  </td>
                  <td></td>
                </tr>
              )}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan="4">
                  {/* <nav aria-label="...">
                    <ul className="pagination">
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(currentPage - 1)}
                        >
                          Previous
                        </button>
                      </li>
                      {Array.from({
                        length: Math.ceil(leave.length / itemsPerPage),
                      }).map((_, index) => (
                        <li
                          key={index}
                          className={`page-item ${
                            currentPage === index + 1 ? "active" : ""
                          }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => paginate(index + 1)}
                          >
                            {index + 1}
                          </button>
                        </li>
                      ))}
                      <li
                        className={`page-item ${
                          currentPage === Math.ceil(leave.length / itemsPerPage)
                            ? "disabled"
                            : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(currentPage + 1)}
                        >
                          Next
                        </button>
                      </li>
                    </ul>
                  </nav> */}
                  <nav aria-label="...">
                    <ul className="pagination">
                      <li
                        className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(currentPage - 1)}
                        >
                          Previous
                        </button>
                      </li>
                      {Array.from({
                        length: Math.ceil(leave.length / itemsPerPage),
                      }).map((_, index) => {
                        if (
                          index + 1 >= currentPage - 4 && // Display 4 pages before current page
                          index + 1 <= currentPage + 5 // Display 5 pages after current page
                        ) {
                          return (
                            <li
                              key={index}
                              className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
                            >
                              <button
                                className="page-link"
                                onClick={() => paginate(index + 1)}
                              >
                                {index + 1}
                              </button>
                            </li>
                          );
                        }
                        return null; // Hide pages outside the range
                      })}
                      <li
                        className={`page-item ${currentPage === Math.ceil(leave.length / itemsPerPage) ? "disabled" : ""}`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(currentPage + 1)}
                        >
                          Next
                        </button>
                      </li>
                    </ul>
                  </nav>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      {/* masterModel */}
      <CustomModal
        open={masterModel}
        onClickOutside={() => {
          setMasterModel(false);
          setCreateLeave({});
        }}
      >
        <form
          onSubmit={(e) => {
            handleUpdate(e);
          }}
        >
          <div className="modal-content Modal-View  m-auto">
            <div className="modalHeader text-center py-2">
              <h5 className="font-bold mt-2">Update Leave Master</h5>
            </div>
            <div className="modal-body p-0 ">
              <div className="container">
                <div className="row d-flex align-items-center justify-content-center  mt-0">
                  <div className="container ">
                    <div className="row justify-content-center">
                      <div className="col-lg-8">
                        <div className=" my-5 px-3">
                          <div className="row justify-content-center mt-2">
                            <div className="col-lg-10">
                              <div className="mb-3">
                                <label className="labeltext">
                                  Name of the Leave:
                                </label>
                                <input
                                  type="text"
                                  className="fieldinput"
                                  placeholder="Enter Name of the Holiday"
                                  defaultValue={createLeave?.name}
                                  onChange={(e) => {
                                    setData(e.target.value, "name");
                                  }}
                                />
                              </div>
                              <div className="mb-3">
                                <label className="labeltext">
                                  Leave Status
                                </label>
                                <select
                                  className="fieldinput"
                                  defaultValue={createLeave?.status}
                                  onChange={(e) => {
                                    setData(e.target.value, "status");
                                  }}
                                >
                                  <option value="">Select Status</option>
                                  <option value="active">Active</option>
                                  <option value="inactive">Inactive</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer border-0">
              <div>
                <button
                  type="button"
                  className="btn mx-2 submit-btn"
                  onClick={() => {
                    setMasterModel(false);
                    setValidation({});
                    setCreateLeave({});
                  }}
                >
                  Back
                </button>
              </div>
              <div>
                <button className="btn mx-2 submit-btn">Update</button>
              </div>
            </div>
          </div>
        </form>
      </CustomModal>
    </>
  );
};

export default Leavemaster;
